import { LoaderIcon } from '@/utils/icons';
import styles from './PendingSpinner.module.css';

/** The small spinner after a name that is still being saved. Decorative: the
 *  row or card around it carries `aria-busy`. */
export function PendingSpinner() {
  return <span className={styles.spinner} aria-hidden="true"><LoaderIcon size={12} /></span>;
}
